export default __webpack_public_path__ + "static/media/chinasa.8b14e2f7.png";